(function () {
    "use strict";

    angular.module("app").factory("codesServiceBase", BaseCodesFactory);
    BaseCodesFactory.$inject = ["$rootScope", "settingsService", "webApiServices", "localStorageService", "chosenCodes",];
    function BaseCodesFactory($rootScope, settingsService, webApiServices, localStorageService, chosenCodes) {

        const store = {
            codes: { loading: false, callbacks: [] },
            partners: { loading: false, callbacks: [] },
            partnersList: { loading: false, callbacks: [] },
            dossierInformation: { loading: false, callbacks: [] },
        };

        const codesDateKey = `${settingsService.appCodeName}_codes_loaded_on`;
        const codesLanguageKey = `${settingsService.appCodeName}_codes_language`;
        const codesKey = `${settingsService.appCodeName}_codes`;
        const partnersListKey = `${settingsService.appCodeName}_partners_list`;
        const partnersListDateKey = `${settingsService.appCodeName}_partners_list_loaded_on`;
        
        // Service interface
        return {
            loadAllCodes,
            getCodePartnersList,
            storeData,
            invokeCallbacks,
        };

        //#region "Implementation of service interface"

        function loadAllCodes(callback) {
            if (angular.isFunction(callback))
                store.codes.callbacks.push(callback);

            if (store.codes.loading)
                return;

            let codes = localStorageService.getByKey(codesKey);

            if (!codes || localStorageService.isOutDated(codesDateKey, codesLanguageKey)) {
                store.codes.loading = true;

                webApiServices.GetAllCodesByLanguage(
                    { LanguageCode: settingsService.locale.substring(0, 2), ChosenCodeTypes: chosenCodes },
                    (result) => {
                        codes = result.data;
                        storeData(result.data, codesDateKey, codesKey, codesLanguageKey);

                        store.codes.loading = false;

                        parseCodesFromJsonToRootScope(codes);

                        invokeCallbacks(store.codes, codes);
                    },
                    err => console.error("Error loading partner codes", err)
                );
            }
            else {
                parseCodesFromJsonToRootScope(codes);
                invokeCallbacks(store.codes, codes);
            }
        }

        function getCodePartnersList(callback) {
            if (angular.isFunction(callback))
                store.partnersList.callbacks.push(callback);

            if (store.partnersList.loading)
                return;

            let partners = localStorageService.getByKey(partnersListKey);

            if (!partners || localStorageService.isOutDated(partnersListDateKey)) {
                store.partnersList.loading = true;

                webApiServices.GetPartnerCodes(
                    (result) => {
                        partners = result.data;
                        storeData(result.data, partnersListDateKey, partnersListKey);
                        store.partnersList.loading = false;
                        invokeCallbacks(store.partnersList, partners);
                    },
                    err => console.error("Error loading partner codes", err)
                );
            }
            else {
                invokeCallbacks(store.partnersList, partners);
            }
        }

        //#endregion

        //#region "Internals"

        function parseCodesFromJsonToRootScope(json) {
            chosenCodes.forEach(code => {
                $rootScope[`code${code}`] = json.find(c => c.Key === code) ? json.find(c => c.Key === code).Value : null;
            });
        }

        function storeData(data, timestampKey, dataKey, languageKey) {
            localStorageService.setByKey(timestampKey, (new Date()).toDateString());
            localStorageService.setByKey(dataKey, data);

            if (languageKey)
                localStorageService.setByKey(languageKey, settingsService.locale.substring(0, 2));
        }

        function invokeCallbacks(store, ...params) {
            for (const cb of store.callbacks)
                cb(...params);

            store.callbacks = [];
        }

        //#endregion
    }
})();